export default __webpack_public_path__ + "twitter-black-shape.png";